import { useState } from 'react';
import dayjs from 'dayjs';
import CloseIcon from '../../../assets/icons/close.svg?react';
import Calendar from '../../../components/Calendar';
import { useCreateOpmContractNumberInfo } from '../../../hooks/queries/resourceRelationQueries';

const OpmContractAppendModal = ({ onClose, drResource, onSuccess }) => {
  const { mutate: createContract, isPending } = useCreateOpmContractNumberInfo();
  const [contractNumber, setContractNumber] = useState('');
  const [dataStartDate, setDataStartDate] = useState(null);
  const [dataEndDate, setDataEndDate] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');

  const formatDate = (d) => (d ? dayjs(d).format('YYYY-MM-DD') : '');

  const isFormValid = !!contractNumber.trim();

  const handleSubmit = () => {
    if (!isFormValid || !drResource?.DrResourceSysId) return;
    setErrorMessage('');

    createContract(
      {
        drResourceSysId: drResource.DrResourceSysId,
        contractNumber: contractNumber.trim(),
        dataStartDate: formatDate(dataStartDate),
        dataEndDate: formatDate(dataEndDate),
      },
      {
        onSuccess: () => {
          onSuccess?.();
          onClose();
        },
        onError: (error) => {
          console.error('OPM 고객계약번호 추가 실패:', error);
          setErrorMessage(
            error?.response?.data?.message ||
              error?.message ||
              'OPM 고객계약번호 추가에 실패했습니다.'
          );
        },
      }
    );
  };

  return (
    <div className="side-modal-background">
      <div className="side-modal-container">
        <div className="side-modal-header">
          <h3>고객계약번호 추가</h3>
          <div className="side-modal-close" onClick={onClose}>
            <CloseIcon />
          </div>
        </div>
        <div className="side-modal-content">
          <table className="transparent-table w-full">
            <tbody>
              <tr>
                <td>
                  <label htmlFor="contractNumber" className="w-20 mr-10 text-b2-700 required">
                    계약번호
                  </label>
                </td>
                <td>
                  <input
                    type="text"
                    id="contractNumber"
                    value={contractNumber}
                    onChange={(e) => setContractNumber(e.target.value)}
                    className="w-full input-primary"
                    placeholder="고객계약번호를 입력해주세요."
                    autoComplete="off"
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <label className="w-20 mr-10 text-b2-700">정보제공시작일</label>
                </td>
                <td>
                  <Calendar
                    mode="single"
                    monthShortCut={false}
                    value={dataStartDate}
                    onChange={setDataStartDate}
                    placeholder="시작일을 선택해주세요."
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <label className="w-20 mr-10 text-b2-700">정보제공종료일</label>
                </td>
                <td>
                  <Calendar
                    mode="single"
                    monthShortCut={false}
                    value={dataEndDate}
                    onChange={setDataEndDate}
                    placeholder="종료일을 선택해주세요."
                  />
                </td>
              </tr>
              {errorMessage && (
                <tr>
                  <td colSpan="2">
                    <p className="text-b3-400 text-red-500 mt-5">{errorMessage}</p>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          <div className="flex justify-end w-full">
            <button
              className="btn big-btn btn-primary flex-1"
              onClick={handleSubmit}
              disabled={isPending || !isFormValid}
            >
              {isPending ? '등록 중...' : '등록하기'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OpmContractAppendModal;
